module.exports = BD.Model.extend({
    daybook: BD.belongsTo('Billy.Daybook', { isParent: true }),
    account: BD.belongsTo('Billy.Account'),
    priority: BD.attr('number')
})
